module.exports = __webpack_public_path__ + "static/media/gM1.c8eb5662.jpg";